import { render, staticRenderFns } from "./Contracts.vue?vue&type=template&id=f0a66506&scoped=true&"
import script from "./Contracts.vue?vue&type=script&lang=ts&"
export * from "./Contracts.vue?vue&type=script&lang=ts&"
import style0 from "./Contracts.vue?vue&type=style&index=0&id=f0a66506&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a66506",
  null
  
)

export default component.exports